/** Legacy Webflow-style post URLs, still routed as `/blog/post/:slug` (and the drafts equivalent). */
const LEGACY_BLOG_POST_PATH =
  /^(?:\/(?:es|de|fr))?\/blog\/post\/[^/]+\/?$|^\/drafts-blog\/post\/[^/]+\/?$/i;

const isLegacyBlogPostPath = (path: string): boolean =>
  LEGACY_BLOG_POST_PATH.test(path.replace(/\/+$/, "") || path);

export default isLegacyBlogPostPath;
